import {Lightbox} from '../classes/Lightbox';

export const initLeadCatcher = ( currentCookies ) => {
	if ( !currentCookies['lead_catch'] )
	{
		const hideNotification = () => {
			const today = new Date();
			const expires = new Date();

			expires.setTime( today.getTime() + ( 1000 * 60 * 60 * 24 ) );
			document.cookie = `lead_catch=lead_catch; expires=${expires.toGMTString()}; path=/`;
		};
		
		fetch( '/ajax/', {
			method: 'POST',
			cache: 'no-cache',
			credentials: 'same-origin',
			body: `action=get-banner&referer=${location.pathname}`,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			referrerPolicy: 'no-referrer',
		} )
			.then( ( response ) => response.json() )
			.then( ( msg ) => {
				if ( !msg.button_href )
				{
					return;
				}
				
				const rendered = `<a href="${msg.button_href}"><picture><source media="(max-width: 635px)" srcset="${msg.image_mobile_src}"><img src="${msg.image_src}" alt="${msg.title}" title="${msg.title}" /></picture></a>`;

				setTimeout( () => {
					if ( !document.body.querySelector( 'div.cds2-lightbox' ) )
					{
						Lightbox.open( rendered, hideNotification, 'lead-catcher' );
					}
				}, msg.delay * 100 );
			} );
	}
};
